import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IGetCounsels,
  ICounselReq,
  ICounselMenuResponse,
  ICounselParams,
  IGetCounselList,
  IGetCounsel,
} from '../models/studentsCounsel.model';
import QueryString from 'qs';

const uri = '/mgmt/students/counsel';

export const getStudentCounsels = (
  memberCode: string,
  campusCode: string,
): AxiosPromise<IGetCounsels> => {
  return axios.get(`${uri}/${memberCode}/${campusCode}`);
};

export const createStudentCounsel = (
  studentCode: string,
  campusCode: string,
  data: ICounselReq,
): AxiosPromise => {
  return axios.post(`${uri}/${studentCode}/${campusCode}`, data);
};

export const updateStudentCounsel = (
  counselCode: number,
  data: ICounselReq,
): AxiosPromise => {
  return axios.put(`${uri}/modify/${counselCode}`, data);
};

export const getStudentCounselMenu = (): AxiosPromise<ICounselMenuResponse> =>
  axios.get(`${uri}/menu`);

export const getCounsels = (params: ICounselParams): AxiosPromise<IGetCounselList> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const getCounsel = (counselCode: number): AxiosPromise<IGetCounsel> => {
  return axios.get(`${uri}/detail/${counselCode}`);
};
